// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d97b8d47","627":"5dd27233","738":"2d47ba63","923":"e312befe"}[chunkId] + ".chunk.js";
};